import { Link } from "react-router-dom";
import type { CastMember } from "@/types";

interface CastCardProps {
  member: CastMember;
  episodeId?: string;
}

export default function CastCard({ member, episodeId }: CastCardProps) {
  const target = episodeId ? `/detail/${episodeId}` : "/category/updates";

  return (
    <Link
      to={target}
      className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
    >
      <div className="h-20 w-20 flex-shrink-0 overflow-hidden rounded-md bg-background-200 sm:h-24 sm:w-24">
        <img
          src={member.avatar}
          alt={`出轨同学会主演${member.name}饰${member.role}`}
          title={`出轨同学会 ${member.name} 饰 ${member.role}`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-2">
          <h3 className="font-heading text-base font-semibold text-foreground-900 transition-colors group-hover:text-primary-700">
            {member.name}
          </h3>
          <span className="rounded bg-accent-100 px-2 py-0.5 font-label text-xs text-accent-800">
            饰 {member.role}
          </span>
        </div>
        <p className="mt-2 line-clamp-2 font-label text-sm leading-relaxed text-foreground-600">
          {member.bio}
        </p>
        <div className="mt-3 flex flex-wrap gap-2">
          {member.tags.map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-label text-[11px] text-secondary-900"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}